<template>
  <div class="p-5 user-profile-page">

    <div class="container" v-if="$ready_user">
      <div class="row">
        <div class="col-lg-4">

          <div class="card" v-if="userPublicClone">
            <div class="card-body">
              <div class="media">
                <!--<img width="128" :src="userAuth.picture" :alt="userAuth.name" />-->
                <a href="#" @click.prevent="showUploadImage" v-tooltip="{ content: 'Click here to upload a new profile picture' }">
                  <span
                    class="avatar avatar-xxl mr-5 clickable"
                    :style="{
                      backgroundImage: 'url(&quot;' + $options.filters.defaultUserPic(userContactInfo.profilePic) + '&quot;)'
                    }">
                      <Spinner v-if="fileUploading" class="p-4" size="large" line-bg-color="#4285f4" line-fg-color="white" />
                    </span>
                </a>
                <input v-show="false" ref="hiddenFileUpload" type="file" size="1" @change="inputImage" />
                <div class="media-body">
                  <h4 class="m-0">
                    <!-- {{userData.academicTitle}} -->
                    {{userPublicClone.firstName}} {{userPublicClone.lastName}}
                    <!--
                    <a class="icon" href="javascript:void(0)"><i class="fe fe-edit"></i></a>
                    -->
                  </h4>
                  <p class="text-muted mb-0">{{userPublicClone.jobTitle}}</p>

                  <!--
                  <ul class="social-links list-inline mb-0 mt-2">
                    <li class="list-inline-item">
                      <a href="javascript:void(0)" title="Facebook" data-toggle="tooltip"><i class="fa fa-facebook"></i></a>
                    </li>
                    <li class="list-inline-item">
                      <a href="javascript:void(0)" title="Twitter" data-toggle="tooltip"><i class="fa fa-twitter"></i></a>
                    </li>
                    <li class="list-inline-item">
                      <a href="javascript:void(0)" title="1234567890" data-toggle="tooltip"><i class="fa fa-phone"></i></a>
                    </li>
                    <li class="list-inline-item">
                      <a href="javascript:void(0)" title="@skypename" data-toggle="tooltip"><i class="fa fa-skype"></i></a>
                    </li>
                  </ul>
                  -->

                </div>
              </div>
            </div>
          </div>

          <div class="card mt-4">
            <div class="card-body" v-if="userSettingsClone">
              <el-switch
                :value="nightMode"
                @change="switchNightMode"
                active-color="grey"
                inactive-color="black">
              </el-switch>
              <span class="ml-2">
                <span v-if="nightMode">Disable Night Mode</span>
                <span v-else>Enable Night Mode</span>
              </span>
            </div>
          </div>

          <div class="card mt-4" v-if="userAuth.email && loggedIn">
            <div class="card-body" v-if="!get_identiy_provider || get_identiy_provider === 'password'">
              <div class="form-group">
                <label class="form-label">Password</label>
                <el-popover
                  placement="right-top"
                  title="Warning">
                  <div>
                    {{password_info_popover_content}}
                  </div>
                  <input
                    slot="reference"
                    type="password"
                    class="form-control"
                    placeholder="New password"
                    ref="password1"
                    id="password1"
                    autocomplete="new-password">
                </el-popover>
              </div>
              <div class="form-group">
                <label class="form-label">Repeat Password</label>
                <input type="password" class="form-control" placeholder="Repeat new password" ref="password2" autocomplete="new-password">
              </div>
              <div class="form-footer">
                <el-button class="btn btn-primary btn-block" @click="updatePassword">Update Password</el-button>
              </div>
            </div>
            <div class="card-body" v-else>
              Using Identiy Provider:<br />
              <strong>{{get_identiy_provider}}</strong>
              <br /><br />
              Name from Identiy Provider:<br />
              <strong>{{userAuth.name}}</strong>
              <!-- TODO: Profile pic from identitify provider -->
            </div>
            <div class="card-body">
              <div class="mt-2" v-if="userAuth && loggedIn">
                <el-button @click="onLogout">Logout</el-button>
              </div>
              <div v-else>
                <!-- TODO: nicht hier -->
                <el-button @click="onLogin">Login</el-button>
              </div>
            </div>
            <div class="card-body">
              <div v-if="isSubscribedToNewsletter" class="mb-4">
                <el-button type="info" plain @click="onSubscribeToNewsletter(false)">Unsubscribe from Newsletter</el-button>
              </div>
              <div v-else class="mb-4">
                <el-button type="info" plain @click="onSubscribeToNewsletter(true)">Subscribe to Newsletter</el-button>
              </div>
              <div class="mb-4">
                <el-button type="info" plain disabled @click="onExportUserData">Export all my data</el-button>
              </div>
              <div>
                <el-button type="danger" plain @click="showDeleteDialog = true">Delete account</el-button>
              </div>

              <el-dialog
                title="Warning"
                :visible.sync="showDeleteDialog"
                width="40%"
                center>
                <span>Are you sure that you want to delete your account?</span>
                <br />
                <el-checkbox v-model="deleteAllData">Delete ALL my data permanently.</el-checkbox>
                <div v-if="deleteAllData" class="p-4">

                  <el-alert
                    title="Are you sure?"
                    type="error"
                    description="This is irreversible"
                    show-icon
                    :closable="false">
                  </el-alert>

                  <p>
                    If yes, type in your email address to confirm deletion of ALL your data:
                  </p>
                  <el-input v-model="confirmDeletionEmailAddress" />

                </div>
                <span slot="footer" class="dialog-footer">
                  <el-button @click="showDeleteDialog = false">Cancel</el-button>
                  <el-button type="danger" @click="onDeleteUser( deleteAllData ? 'hard' : 'soft')">
                    Confirm {{deleteAllData ? 'DANGEROUS' : ''}}
                  </el-button>
                </span>
              </el-dialog>

            </div>
          </div>

        </div>
        <div class="col-lg-8">

          <form class="card" @submit.prevent="onUpdateProfile" v-if="userSettingsClone && userPublicClone">
            <div class="card-body">
              <h3 class="card-title">Edit Profile</h3>
              <el-alert show closable v-if="update_user_info_error" @close="update_user_info_error = ''" variant="danger">
                  {{update_user_info_error}}
              </el-alert>
              <el-alert show closable v-if="update_user_info_success" @close="update_user_info_success = ''" variant="success">
                  {{update_user_info_success}}
              </el-alert>
              <div class="row">
                <!--
                <div class="col-sm-3 col-md-3">
                  <div class="form-group">
                    <label class="form-label">Academic Title</label>
                    <input type="text" class="form-control" placeholder="Academic Title" v-model="userPublicClone.academicTitle" ref="academicTitle">
                  </div>
                </div>
                -->
                <div class="col-sm-4 col-md-4">
                  <div class="form-group">
                    <label class="form-label">First Name</label>
                    <input type="text" class="form-control" placeholder="First Name" v-model="userPublicClone.firstName" ref="firstName">
                  </div>
                </div>
                <div class="col-sm-5 col-md-5">
                  <div class="form-group">
                    <label class="form-label">Last Name</label>
                    <input type="text" class="form-control" placeholder="Last Name" v-model="userPublicClone.lastName" ref="lastName">
                  </div>
                </div>

                <div class="col-sm-12 col-md-12">
                  <div class="form-group">
                    <label class="form-label">Job Title</label>
                    <input type="text" class="form-control" placeholder="Job Title" v-model="userPublicClone.jobTitle" ref="jobTitle">
                  </div>
                </div>

                <div class="col-sm-12 col-md-12">
                  <div class="form-group">
                    <label class="form-label">Email address</label>
                    <input type="email" class="form-control" disabled placeholder="Email" v-model="authClone.email">
                  </div>
                </div>

                <div class="col-sm-6 col-md-6">
                  <div class="form-group">
                    <label class="form-label">Birthday</label>
                    <!-- <el-date-picker type="date" v-model="userPublicClone.birthday" ref="birthday" /> -->
                    <date-selector
                      v-model="userPublicClone.birthday"
                      type="date"
                      placeholder="Last Day">
                      <!-- :user-timezone-overwrite="null" -->
                    </date-selector>
                  </div>
                </div>

                <div class="col-sm-6 col-md-6">
                  <div class="form-group">
                    <label class="form-label">Timezone</label>
                    <timezone-picker v-model="userSettingsClone['settings.timezone']" />
                  </div>
                </div>

                <div class="col-sm-6 col-md-6">
                  <div class="form-group">
                    <label class="form-label">Language</label>
                    <el-select
                      v-model="userSettingsClone['settings.language']"
                      placeholder="Select language">
                      <el-option
                        v-for="item in availableLanguages"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        <span style="float: left">{{ item.label }}</span>
                        <span style="float: right; font-size: 13px">{{ item.icon }}</span>
                      </el-option>
                    </el-select>
                  </div>
                </div>

                <div class="col-sm-6 col-md-6">
                  <div class="form-group">
                    <label class="form-label">Date Format</label>
                    <el-select
                      v-model="userSettingsClone['settings.dateformat']"
                      placeholder="Select Date Format">
                      <el-option
                        v-for="item in availableDateformats"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        <span style="float: left">{{ item.label }}</span>
                        <span style="float: right; font-size: 13px">{{ item.icon }}</span>
                      </el-option>
                    </el-select>
                  </div>
                </div>

                <!--
                <div class="col-md-12">
                  <div class="form-group mb-0">
                    <label class="form-label">About Me</label>
                    <textarea rows="5" class="form-control" placeholder="Here can be your description" value="Mike">Oh so, your weak rhyme
          You doubt I'll bother, reading into it
          I'll probably won't, left to my own devices
          But that's the difference in our opinions.</textarea>
                  </div>
                </div>
                -->

              </div>
            </div>
            <div class="card-footer text-right">
              <el-button type="submit" class="btn btn-primary" :disabled="updating_user_info">Update Profile</el-button>
            </div>
          </form>

          <form class="card mt-4" @submit.prevent="onUpdateProfile" v-if="userSettingsClone">
            <div class="card-body">
              <h3 class="card-title">Edit Billing Address and Subscription</h3>
              <el-alert show closable v-if="update_address_error" @close="update_address_error = ''" variant="danger">
                  {{update_address_error}}
              </el-alert>
              <el-alert show closable v-if="update_address_success" @close="update_address_success = ''" variant="success">
                  {{update_address_success}}
              </el-alert>
              <div class="row">
                <div class="col-md-8">
                  <div class="form-group">
                    <label class="form-label">Address</label>
                    <input type="text" class="form-control" placeholder="Home Address" v-model="userSettingsClone['address.address']">
                  </div>
                </div>
                <div class="col-sm-4 col-md-4">
                  <div class="form-group">
                    <label class="form-label">City</label>
                    <input type="text" class="form-control" placeholder="City" v-model="userSettingsClone['address.city']">
                  </div>
                </div>
                <div class="col-sm-3 col-md-3">
                  <div class="form-group">
                    <label class="form-label">Postal Code</label>
                    <input type="number" class="form-control" placeholder="ZIP Code" v-model="userSettingsClone['address.zip']">
                  </div>
                </div>
                <div class="col-sm-3">
                  <div class="form-group">
                    <label class="form-label">Country</label>
                    <input type="text" class="form-control" placeholder="Country" v-model="userSettingsClone['address.country']">
                    <!--
                    <select class="form-control custom-select" v-model="userSettingsClone['address.country']">
                      <option value="DE">Germany</option>
                      <option value="US">United States of America</option>
                    </select>
                    -->
                  </div>
                </div>
                <!--
                <div class="form-group">
                  <label class="form-label">Countries</label>
                  <select name="country" id="select-countries" class="form-control custom-select selectized" tabindex="-1" style="display: none;">
                    <option value="de" selected="selected">Germany</option>
                  </select>
                  <div class="selectize-control form-control custom-select single">
                    <div class="selectize-input items has-options full has-items">
                      <div data-value="de"><span class="image">
                        <img src="./assets/images/flags/de.svg" alt=""></span>Germany
                      </div>
                      <input autocomplete="off" tabindex="" id="select-countries-selectized" style="width: 4px; opacity: 0; position: absolute; left: -10000px;" type="text">
                    </div>
                    <div class="selectize-dropdown single form-control custom-select" style="display: none; visibility: visible; width: 359.333px; top: 38px; left: 0px;">
                      <div class="selectize-dropdown-content">
                        <div data-selectable="" data-value="br" class="">
                          <span class="image"><img src="./assets/images/flags/br.svg" alt=""></span>
                          <span class="title">Brazil</span></div><div data-selectable="" data-value="cz" class="">
                          <span class="image"><img src="./assets/images/flags/cz.svg" alt=""></span>
                          <span class="title">Czech Republic</span></div><div data-selectable="" data-value="de" class="selected active"><span class="image"><img src="./assets/images/flags/de.svg" alt=""></span>
                          <span class="title">Germany</span></div><div data-selectable="" data-value="pl" class="selected">
                          <span class="image"><img src="./assets/images/flags/pl.svg" alt=""></span>
                          <span class="title">Poland</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                -->
                <div class="col-sm-6 col-md-6">
                  <div class="form-group">
                    <label class="form-label">Phone</label>
                    <input type="tel" class="form-control" placeholder="+1 2345 786980" v-model="userSettingsClone['address.phone']">
                  </div>
                </div>
                <hr>
                <div class="col-sm-8">
                  <label class="form-label">Current subscription</label>
                  <div class="form-group">
                    <input type="text" class="form-control" disabled="disabled" v-model="userReadonly.subscription">
                  </div>
                </div>
              </div>
            </div>
            <div class="card-footer text-right">
              <el-button type="submit" class="btn btn-secondary mr-4" @click="onGoToMangeLicenses">Mange Licenses</el-button>
              <el-button type="submit" class="btn btn-secondary mr-4" @click="onChangeSubscription">Change Subscription</el-button>
              <el-button type="submit" class="btn btn-primary" :disabled="updating_address">Update Address</el-button>
            </div>
          </form>

          <div class="card mt-4">
            <div class="card-body">
              <h3 class="card-title">API</h3>
              <el-button @click="onGenerateAPIKey">Generate API Key</el-button>
            </div>
          </div>

          <div class="card mt-4" v-if="SHOW_DEBUG">
            <pre class="card-body" v-if="userSettingsClone && userPublicClone">
              <h3 class="card-title">Userdata (DEBUG)</h3>
userSettingsClone: {{userSettingsClone}}
userPublicClone: {{userPublicClone}}

Firebase Auth Profile: {{userAuth !== undefined}}
Firestore DB Profile: {{userSettingsClone !== undefined}}

UserID (auth): {{userAuth.id}}
createdAt: {{userReadonly.createdAt}}

Settings:
<!--
Night Mode: {{userSettingsClone.settings.nightMode}}
Timezone: {{userSettingsClone.settings.timezone}}
Dateformat: {{userSettingsClone.settings.dateformat}}
Language: {{userSettingsClone.settings.language}}
DateFormat: {{userSettingsClone.settings.dateFormat}}
-->

E-Mail: {{userSettingsClone.email}} // {{authClone.email}}
Country: {{userSettingsClone.address.country}}
phone: {{userSettingsClone.address.phone}}

Subscription: {{userReadonly.subscription}}

ProfilePic: {{userPublicClone.profilePic}}
ProfilePic from ID-Provider: {{userAuth.picture}} ???
ProfilePic: {{userContactInfo.profilePic}}

userContactInfo: {{userContactInfo}}

UserAuth: {{userAuth}}
            </pre>
          </div>

        </div>
      </div>
    </div>

  </div>
</template>

<script>
import Spinner from "vue-simple-spinner";
import firebase from "@firebase/app";
import { mapReady } from "@/api/misc";
import { mapGetters } from "vuex";
import moment from "@/moment-gp";
import storage from "@/generic_api/firebase/storage";
import TimezonePicker from '@/components/Elements/TimezonePicker'
import { availableLanguages } from '@/i18n/available-languages'
// import clonedeep from 'lodash.clonedeep'

// TODO: Auto complection does not update all fields

/* TODO: Ask for password before updating to new pw
  this.reauthenticate(currentPassword).then(() => {...
  https://medium.com/@ericmorgan1/change-user-email-password-in-firebase-and-react-native-d0abc8d21618 */

export default {
  name: "UserProfilePage",
  data() {
    return {
      password_info_popover_show: false,
      updating_user_info: false,
      updating_address: false,
      update_user_info_error: '',
      update_user_info_success: '',
      update_address_error: '',
      update_address_success: '',
      password_info_popover_content: '',
      fileUploading: false,
      showDeleteDialog: false,
      deleteAllData: false,
      isSubscribedToNewsletter: false, // TODO
      confirmDeletionEmailAddress: '',
      availableLanguages: availableLanguages,
      authClone: {},
      userPublicClone: null,
      userSettingsClone: null,
    };
  },
  created() {

    let userPublic = this.$models.userPublic.subscribeNode( this.$models.user.defaultUserId )
    let userSettings = this.$models.userSettings.subscribeNode( this.$models.user.defaultUserId )

    console.log("userPublic", userPublic)

    userPublic.$promise.then(() => {
      this.userPublicClone = userPublic.clone();
    })
    userSettings.$promise.then(() => {
      this.userSettingsClone = userSettings.clone();
    })

    let currentUser = firebase.auth().currentUser
    this.authClone = {
      email:       currentUser.email,
      displayName: currentUser.displayName,
      // photoURL:    currentUser.photoURL,
      phoneNumber: currentUser.phoneNumber,
    }

    // this.userDataClone = clonedeep( this.userData );
    // this.userDataClone = this.userData.clone();
    // if ( !this.userDataClone.address ) {
    //   this.userDataClone.address = {};
    // }
    // this.userSettings.email = this.userSettings.email || this.userAuth.email; // HACK

    //if ( 'seconds' in this.userDataClone.birthday ) {
      // TODO: Convert in store! moment.fromFirestore()
      // this.userDataClone.birthday = new Date( this.userDataClone.birthday['seconds'] * 1000 );
    // this.userDataClone.birthday = moment.fromFirestore( this.userDataClone.birthday );
    //}
  },
  computed: {
    ...mapReady("user"),
    ...mapGetters("user", [
      "userAuth",
      "userData",
      "loggedIn",
      // "get_identiy_provider",
    ]),

    /* userAuth() {
      return firebase.auth().currentUser
    }, */

    userReadonly() {
      return this.$models.userReadonly.subscribeNode( this.$models.user.defaultUserId )
    },

    userContactInfo() {
      return this.$models.userContact.get_contact_by_id( this.$models.user.defaultUserId ) || {};
    },

    get_identiy_provider() {
      // let currentUser = this.userAuth; /* for reactivity */
      let currentUser = firebase.auth().currentUser;

      /* TODO: Das funktioniert nur wenn User bereits geladen ist, also nicht bei refresh auf profile Seite */
      // console.log("get_identiy_provider", clonedeep( firebase.auth() ) );

      if ( currentUser &&
           'providerData' in currentUser &&
           currentUser.providerData &&
           currentUser.providerData.length >= 1 ) {
        return currentUser.providerData[0].providerId;
      } else {
        return null;
      }
    },

    /* local_time() {
      return moment()
        .tz(this.userContactInfo.timeZone)
        .format("LLL");
    }, */

    availableDateformats() {
      return ['L', 'l', 'LL', 'll', 'LLL', 'lll', 'LLLL', 'llll'].map(format => {
        return {
          value: format,
          label: moment().format(format)
        }
      })
    },

    nightMode() {
      let userSettings = this.$models.userSettings.getData( this.$models.user.defaultUserId )
      return ( userSettings && userSettings.settings ) ? userSettings.settings.nightMode : false;
    },

    /* profilePic() {
      // return this.$models.userSettings.getters.get_profile_pic
      return this.userPublicClone ? this.userPublicClone.profilePic : '';
    }, */
  },
  methods: {
    onLogout() {
      this.$api.auth_logout()
    },

    onLogin() {
      this.$api.auth_login()
    },

    switchNightMode() {
      this.$models.userSettings.update( this.$models.user.defaultUserId, {
        "settings/nightMode": !this.nightMode
      })
    },

    inputImage(evt) {
      /* TODO: move to store */
      console.log("inputImage", evt);

      let PROFILE_PIC_USER_EXTENSION = false;

      let file = evt.target.files[0];

      if ( this.fileUploading ) {
        return;
      }
      this.fileUploading = true;

      let userId = this.userAuth.id;
      var imageRef = null;
      let imageRefThumb = null;
      if ( PROFILE_PIC_USER_EXTENSION ) {
        let extension = file.type.split("/").pop()
        imageRef = storage.child(`profile_pics/${userId}.${extension}`);
        imageRefThumb = storage.child(`profile_pics/thumb_${userId}.${extension}`);
      } else {
        imageRef = storage.child(`profile_pics/${userId}`);
        imageRefThumb = storage.child(`profile_pics/thumb_${userId}`);
      }

      imageRef.put(file).then((snapshot) => {
        let NumOfTries = 5;
        let setProfilePicUrl = () => {
         imageRefThumb.getDownloadURL().then((url) => {
           this.$api.user_update_profile_picture({ profilePicUrl : url });
           this.fileUploading = false;
         }).catch((error) => {
           console.log("cloud function not ready. Retrying...", error);

           /* HACK: Wait until cloud function has processed image */
           NumOfTries = NumOfTries - 1;
           if ( NumOfTries > 0) {
             setTimeout(setProfilePicUrl, 2000);
           }
         })
        }
        setTimeout(setProfilePicUrl, 1000);
      });
    },

    showUploadImage() {
      // click hidden file input
      this.$refs.hiddenFileUpload.click()
    },

    onUpdateProfile() {
      /*
      let updatedUserPublicData = {
        academicTitle: this.userDataClone.academicTitle,
        firstName: this.userDataClone.firstName,
        lastName: this.userDataClone.lastName,
        jobTitle: this.userDataClone.jobTitle,
        birthday: this.userDataClone.birthday,
      }
      let updatedUserData = {
        'settings/timezone': this.userDataClone.settings.timezone,
        'settings/dateformat': this.userDataClone.settings.dateformat,
        'settings/language': this.userDataClone.settings.language
      }

      this.$api.user_update_settings(updatedUserData)
      */

      /* When updating userDataClone.settings.timezone update local storage */
      // TODO: Move to store
      let oldUserTimezone = localStorage.getItem('timezone');
      localStorage.setItem('timezone',   this.userSettingsClone.settings.timezone);
      localStorage.setItem('language',   this.userSettingsClone.settings.language);
      localStorage.setItem('dateformat', this.userSettingsClone.settings.dateformat);

      // TODO Use user_update_language to update language

      this.userSettingsClone.write().then(() => {
        // WORKAROUND: Store and components are now in the wrong timezone -
        //             we need to reload the entire page
        let user_get_timezone = this.$models.userSettings.getters.user_get_timezone;
        if ( this.userSettingsClone.settings.timezone !== user_get_timezone ||
             this.userSettingsClone.settings.timezone !== oldUserTimezone ) {
             /* TODO: check which one is correct ^ */

          this.$message({
            dangerouslyUseHTMLString: true,
            type: 'success',
            message: `<strong>After updating the timezone you need to reload the app. Click <a href="javascript:location.reload()">reload</a></strong>`,
            duration: 0,
          });

          // location.reload();
        }
      });

      // this.$api.user_update_public_profile(updatedUserPublicData)
      this.updating_user_info = true;
      this.userPublicClone.write().then(() => {
        this.updating_user_info = false;
        this.update_user_info_success = 'User profile successfully updated';
        // setTimeout(() => {this.update_user_info_success = ''}, 2000)
      }).catch((error) => {
        this.update_user_info_error = error;
        this.updating_user_info = false;
      });

      let currentUser = firebase.auth().currentUser;
      /* email is saved in auth AND firebase */
      this.authClone.email = this.userSettingsClone.email
      this.authClone.phoneNumber = this.userSettingsClone.address.phone
      this.authClone.displayName = this.userPublicClone.firstName + ' '
                                 + this.userPublicClone.lastName;

      currentUser.updateProfile(this.authClone).then(() => {
        // Profile updated successfully!
      });
    },

    /*
    update_address() {
      // TODO: Use stripe for data storage in the future

      let updatedUserData = {
        'address.address': this.userDataClone.address.address || '',
        'address.city':    this.userDataClone.address.city || '',
        'address.zip':     this.userDataClone.address.zip || 0,
        'address.phone':   this.userDataClone.address.phone || '',
        'address.country': this.userDataClone.address.country || '',
      }

      this.updating_address = true;
      this.$api.user_update_settings(updatedUserData).then(() => {
        this.updating_address = false;
        this.update_user_info_success = 'Address successfully updated';
      }).catch((error) => {
        this.update_user_info_error = error;
        this.updating_address = false;
      });
    },
    */

    updatePassword() {
      /* DOWN ALLOW WHEN ID PROVIEDER IS USERD */

      if ( this.get_identiy_provider ) {
        console.log("Not allowed");
        return;
      }

      let pw1 = this.$refs.password1.value;
      let pw2 = this.$refs.password2.value;
      this.password_info_popover_content = '';

      if ( pw1 !== pw2 ) {
        this.password_info_popover_content = 'Password not identically.'
        this.$refs.password_popover.$emit('open')
        return
      }

      if ( !pw1 || !pw2 || pw1.length < 6 ) {
        this.password_info_popover_content = 'Password must be at least 6 characters.'
        return
      }

      if (this.password_info_popover_content) {
        setTimeout(() => { /* HACK */
          this.$refs.password_popover.$emit('open')
        }, 100)
      }

      this.$api.auth_update_password({ userPassword: pw1 }).then(() => {
        console.log("Password updated successfully")
        this.$refs.password1.value = '';
        this.$refs.password2.value = '';
        this.$refs.password_popover.$emit('close')
        this.password_info_popover_content = '';
        alert("Password updated successfully") /* TODO */
      }).catch((error) => {
        this.password_info_popover_content = 'Updating password failed\n' + error;
        this.$refs.password_popover.$emit('open')
      });
    },

    onDeleteUser( mode ) {
      if ( mode === 'soft' ) {
        this.$api.user_soft_delete();
      }

      if ( mode === 'hard' ) {
        this.$confirm('This will permanently delete all goals, tasks, visionboards. Continue?', 'Warning', {
          confirmButtonText: 'OK, I understand',
          cancelButtonText: 'No, I changed my mind',
          type: 'warning'
        }).then(() => {
          this.$api.user_hard_delete({
            confirm: this.confirmDeletionEmailAddress
          }).then(() => {
            this.$message({
               type: 'success',
               message: 'Deletion successfull'
             });
             // TODO: LOGOUT
          }).catch(e => {
            this.$message.error('Deletion failed with error' + e);
          });
        });
      }
    },

    onSubscribeToNewsletter( subscribe ) {
      if ( subscribe ) {
        throw new Error('NOT IMPLEMENTED');
      } else {
        throw new Error('NOT IMPLEMENTED');
      }
    },

    onExportUserData() {
      throw new Error('NOT IMPLEMENTED');
    },

    onGenerateAPIKey() {
      firebase.auth().currentUser.getIdToken(/* forceRefresh */ true).then((idToken) => {
        return this.$prompt('Your API Key', 'Goalpilot API', {
          confirmButtonText: 'OK',
          showCancelButton: false,
          inputType: 'textarea',
          inputValue: idToken,
          closeOnClickModal: false, // ?
        });
      }).catch(e => {});
    },

    onChangeSubscription() {
      this.$router.push('/upgrade')
    },

    onGoToMangeLicenses() {
      this.$router.push('/licenses')
    },
  },
  components: {
    Spinner,
    TimezonePicker
  }
};
</script>

<style>
.user-profile-page .form-label {
  display: block;
}
.user-profile-page .avatar {
  border: 1px solid white;
}
.user-profile-page .avatar:hover {
  border: 1px dashed black;
}
</style>
